
import React, { useState } from "react";
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useMediaQuery } from "@/hooks/use-media-query";
import { useNavigation } from "./NavigationContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { 
  Home, 
  BarChart, 
  Users, 
  Star, 
  Briefcase, 
  Building, 
  FileText,
  Target,
  LucideIcon
} from "lucide-react";
import DesktopNav from "./DesktopNav";
import MobileMenu from "./MobileMenu";
import NavActions from "./NavActions";

const MainNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [favorites] = useLocalStorage<number[]>('user_favorites', []);
  const { t } = useLanguage();

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  const navItems: Array<{
    label: string;
    href: string;
    icon: LucideIcon;
    badge?: number | null;
  }> = [
    { label: t('home'), href: "/", icon: Home },
    { label: t('dashboard'), href: "/dashboard", icon: BarChart },
    { 
      label: t('favorites'), 
      href: "/favorites", 
      icon: Star,
      badge: favorites.length > 0 ? favorites.length : null
    },
    { label: t('collaborative-space'), href: "/collaborative-space", icon: Users },
    { label: t('prestataire-space'), href: "/prestataire-space", icon: Briefcase },
    { label: t('contact-collectivites'), href: "/contact-collectivites", icon: Building },
    { label: t('api-docs'), href: "/api-docs", icon: FileText },
    { label: t('impact'), href: "/impact", icon: Target }
  ];

  return (
    <nav className="bg-background/95 backdrop-blur border-b border-border fixed w-full top-0 z-50 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            {!isMobile ? (
              <DesktopNav navItems={navItems} />
            ) : (
              <div className="flex-shrink-0 flex items-center">
                <a href="/" className="font-display text-xl font-bold tracking-tight text-primary">
                  {t('app.name')}
                </a>
              </div>
            )}
          </div>
          
          <NavActions 
            navItems={navItems}
            isMobile={isMobile}
            isOpen={isOpen}
            toggleNav={toggleNav}
          />
        </div>
      </div>

      {isMobile && (
        <MobileMenu 
          isOpen={isOpen}
          navItems={navItems}
          setIsOpen={setIsOpen}
        />
      )}
    </nav>
  );
};

export default MainNav;
